// extracted by mini-css-extract-plugin
var _1 = "default-k7lRO";
var _2 = "danger-TiPj9";
var _3 = "footer-V1OFm";
var _4 = "left-mDPxj";
var _5 = "primary-Xrzz1";
var _6 = "right-G_yyo";
var _7 = "selected-DUjHJ";
var _8 = "success-ogJOA";
var _9 = "warning-UvopR";
export { _1 as "_default", _2 as "danger", _3 as "footer", _4 as "left", _5 as "primary", _6 as "right", _7 as "selected", _8 as "success", _9 as "warning" }
